import { GlFormGroup, GlFormRadioGroup } from '@gitlab/ui';
import LocalStorageSync from '~/vue_shared/components/local_storage_sync.vue';
export default {
    name: 'PersistedRadioGroup',
    components: {
        GlFormGroup,
        GlFormRadioGroup,
        LocalStorageSync
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        storageKey: {
            type: String,
            required: true
        }
    },
    emits: [
        'change'
    ],
    data () {
        return {
            selected: this.options[0].value
        };
    },
    computed: {
        radioOptions () {
            return this.options.map((option)=>({
                    value: option.value,
                    text: option.label
                }));
        }
    },
    methods: {
        setSelected (value) {
            this.selected = value;
            this.$emit('change', value);
        }
    }
};
